import {
  useProcessDirectGasEmissionsImport,
  useProcessElectricityImport,
  useProcessHeatImport,
  useProcessMobileCombustionImport,
  useProcessStationaryCombustionImport,
} from '@shared/api/hooks/ccf/imports';
import { Scope1And2CategorySlug } from './config';

/**
 * Returns the process-import mutation for a given Scope 1/2 category. All five
 * wrappers are instantiated (hooks must run unconditionally) and the matching
 * one is selected by slug.
 */
export const useScope1And2ImportMutation = (slug: Scope1And2CategorySlug) => {
  const electricity = useProcessElectricityImport();
  const heat = useProcessHeatImport();
  const stationaryCombustion = useProcessStationaryCombustionImport();
  const mobileCombustion = useProcessMobileCombustionImport();
  const directGasEmissions = useProcessDirectGasEmissionsImport();

  switch (slug) {
    case 'electricity':
      return electricity;
    case 'heat':
      return heat;
    case 'stationary-combustion':
      return stationaryCombustion;
    case 'mobile-combustion':
      return mobileCombustion;
    case 'direct-gas-emissions':
      return directGasEmissions;
  }
};
